<template>
  <div>
    <h4 class="info-text">
      Votre expérience des marchés
    </h4>
    <div class="row justify-content-center mt-5">
      <div class="col-md-6 text-center">
        <el-select
          class="select-primary"
          size="large"
          placeholder="Single Select"
          v-model="model.experience"
        >
          <el-option
            v-for="option in experiences"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="row justify-content-center mt-5">
      <div class="col-md-6 text-center">
        <div v-if="model.experience==1">
          Je découvre les {{mode === 'crypto' ? 'cryptos' : 'marchés financiers'}} et souhaite y investir pour obtenir un rendement intéressant.
        </div>
        <div v-if="model.experience==2">
          J'ai déjà au moins deux ans d'expériences et je connais les {{mode === 'crypto' ? 'cryptos' : 'marchés financiers'}}. 
          Je sais manipuler les différents types d'ordres.
        </div>
        <div v-if="model.experience==3">
          J'ai plusieurs années d'expériences, et j'ai vécu des périodes de forte volatilité.
          J'ai un money management et des règles strictes.
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { Select, Option } from 'element-ui';
import { mapGetters } from 'vuex';

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select
  },
  data() {
    return {
      model: {
        experience: 1
      },
      experiences: [
          { value: 1, label: 'Débutant' },
          { value: 2, label: 'Intermédiaire' },
          { value: 3, label: 'Expérimenté' },
      ],
      modelValidations: {
        conditionsAccepted: {
          required: true,
          min: 5
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      mode: 'auth/mode',
    }),
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        this.$emit('on-validated', res, this.model);
        return res;
      });
    }
  }
};
</script>
<style></style>
